var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationMockups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 709,
    height: 506,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 657.638,
    height: 410.833,
    rx: 13.701
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-2.6%",
    width: "103.2%",
    height: "105.1%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 0h630.237c7.567 0 13.7 6.134 13.7 13.7v30.122H0V13.701C0 6.134 6.134 0 13.7 0z",
    id: "d"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-24%",
    width: "103.2%",
    height: "147.9%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.811%",
    y1: "-22.362%",
    x2: "75.996%",
    y2: "119.406%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.973%",
    y1: "0%",
    x2: "90.2%",
    y2: "111.244%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF52C1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9952FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.691 0h195.83c6.457 0 11.692 5.234 11.692 11.691v327.195c0 6.457-5.235 11.692-11.692 11.692H11.691C5.234 350.578 0 345.343 0 338.886V11.691C0 5.234 5.234 0 11.691 0z",
    id: "i"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-2.6%",
    width: "108.2%",
    height: "105.1%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.691 0h195.83c6.457 0 11.692 5.234 11.692 11.691v25.704H0V11.691C0 5.234 5.234 0 11.691 0z",
    id: "k"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-24.1%",
    width: "108.2%",
    height: "148.1%",
    filterUnits: "objectBoundingBox",
    id: "j"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00252E",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E1E8EE",
    x: 49.323,
    y: 13.694,
    width: 137.008,
    height: 16.433,
    rx: 3.425
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(591.874 15.064)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.921,
    height: 2.739,
    rx: 1.369
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.478,
    width: 21.921,
    height: 2.739,
    rx: 1.369
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 21.921,
    height: 2.739,
    rx: 1.369
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.323 94.492)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#e)",
    cx: 32.882,
    cy: 32.867,
    rx: 32.882,
    ry: 32.867
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.126 8.217)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.78,
    height: 10.956,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.911,
    width: 274.016,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32.867,
    width: 251.181,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 43.822,
    width: 228.346,
    height: 5.478,
    rx: 2.055
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.024 24.65)",
    fill: "#A7B9C8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.22,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.063,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.142,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.984,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.906,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.323 187.614)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#f)",
    cx: 30.827,
    cy: 30.813,
    rx: 30.827,
    ry: 30.813
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.07 6.162)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.78,
    height: 10.956,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.911,
    width: 274.016,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32.867,
    width: 251.181,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 43.822,
    width: 228.346,
    height: 5.478,
    rx: 2.055
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.969 22.596)",
    fill: "#A7B9C8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.22,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.063,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.142,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.323 285.53)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#g)",
    cx: 30.827,
    cy: 30.813,
    rx: 30.827,
    ry: 30.813
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.07 6.162)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.78,
    height: 10.956,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.911,
    width: 274.016,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32.867,
    width: 251.181,
    height: 5.478,
    rx: 2.055
  }), /*#__PURE__*/React.createElement("rect", {
    y: 43.822,
    width: 228.346,
    height: 5.478,
    rx: 2.055
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.969 22.596)",
    fill: "#A7B9C8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.22,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.063,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.142,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.984,
    cy: 8.217,
    rx: 8.22,
    ry: 8.217
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483.787 149.422)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483.787 149.422)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#j)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00252E",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.8 162.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E1E8EE",
    width: 71.244,
    height: 14.023,
    rx: 2.923
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.111 1.169)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.706,
    height: 2.337,
    rx: 1.169
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.674,
    width: 18.706,
    height: 2.337,
    rx: 1.169
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.349,
    width: 18.706,
    height: 2.337,
    rx: 1.169
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 223.372)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#e)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 317.864)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#e)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 254.87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#f)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 349.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#f)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 286.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#g)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 380.858)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#g)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 412.356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#e)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.709 443.853)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.512 2.054)",
    fill: "#E1E8EE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.39,
    height: 3.652,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.304,
    width: 137.008,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.956,
    width: 125.591,
    height: 1.826,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.607,
    width: 114.173,
    height: 1.826,
    rx: 0.63
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#f)",
    cx: 10.276,
    cy: 10.271,
    rx: 10.276,
    ry: 10.271
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMockups);
export default __webpack_public_path__ + "static/media/illustration-mockups.264994a533e88e58ad2a10b6ae6856e0.svg";
export { ForwardRef as ReactComponent };